import React, { useRef } from 'react';

import { createPortal } from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import { useSelector } from 'react-redux';

import { PAGE_TYPE_AREA } from 'constants/index';
import { useEscAction } from 'hooks/useEscAction';
import { isModalOpenedSelector } from 'store/modal/selectors';
import noop from 'utils/noop';

import SelectPage from '../../../shared/SelectPage';
import { getNormalizedPositionStyles, useEditorContext, EDITING_BLOCK_TYPES } from '../context';
import styles from './index.module.css';

function MyOwnAreaSelect() {
  const { editingBlockState, resetEditingBlockState, mountEl, handleAddAreaToEntity } = useEditorContext();
  const isPreviewModalOpen = useSelector(isModalOpenedSelector('PAGE_PREVIEW'));
  useEscAction(isPreviewModalOpen ? noop : resetEditingBlockState);
  const containerRef = useRef();

  return (
    <>
      {createPortal(
        <OutsideClickHandler onOutsideClick={isPreviewModalOpen ? noop : resetEditingBlockState}>
          <div
            className={styles.container}
            ref={containerRef}
            style={getNormalizedPositionStyles(editingBlockState.blockRect, mountEl, containerRef.current)}
          >
            <SelectPage
              forItinerary
              pageType={PAGE_TYPE_AREA}
              onChange={(area) => {
                if (area) handleAddAreaToEntity({ name: area.name, id: area.id, handle: area.handle });
                resetEditingBlockState();
              }}
              autoFocus
              placeholder="Maasai Mara"
              extraLoadOptionsParams={{ countryId: editingBlockState.data.countryId }}
              extraCreatePageParams={{ countryId: editingBlockState.data.countryId }}
            />
          </div>
        </OutsideClickHandler>,
        mountEl,
      )}
    </>
  );
}

function MyOwnAreaSelectContainer() {
  const { editingBlockState } = useEditorContext();

  if (!editingBlockState.isOpen || editingBlockState.blockType !== EDITING_BLOCK_TYPES.AREA_SELECT) {
    return null;
  }

  return <MyOwnAreaSelect />;
}

export default MyOwnAreaSelectContainer;
